var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.9375C13.4848 12.9375 15.0938 11.3285 15.0938 9.34375C15.0938 7.35898 13.4848 5.75 11.5 5.75C9.51523 5.75 7.90625 7.35898 7.90625 9.34375C7.90625 11.3285 9.51523 12.9375 11.5 12.9375Z",
    stroke: "#394150",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 20.125C16.5312 18.7906 16.0012 17.5109 15.0576 16.5674C14.1141 15.6238 12.8344 15.0938 11.5 15.0938C10.1656 15.0938 8.88591 15.6238 7.94237 16.5674C6.99883 17.5109 6.46875 18.7906 6.46875 20.125H16.5312Z",
    stroke: "#394150",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10.0625C17.8626 10.0625 18.465 9.90591 19 9.60761C19.5351 9.30931 19.985 8.87919 20.307 8.3581C20.6291 7.83701 20.8126 7.24224 20.8401 6.63028C20.8677 6.01832 20.7383 5.40948 20.4643 4.86158C20.1904 4.31367 19.7809 3.84489 19.2748 3.49974C18.7688 3.15459 18.1828 2.94454 17.5727 2.88952C16.9626 2.83451 16.3486 2.93636 15.7889 3.18541C15.2293 3.43446 14.7425 3.82244 14.375 4.3125",
    stroke: "#394150",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 17.25H22.2812C22.2812 15.9156 21.7512 14.6359 20.8076 13.6924C19.8641 12.7488 18.5844 12.2188 17.25 12.2188",
    stroke: "#394150",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 4.3125C8.25745 3.82244 7.77074 3.43446 7.21107 3.18541C6.6514 2.93636 6.03736 2.83451 5.42726 2.88952C4.81716 2.94454 4.23124 3.15459 3.72516 3.49974C3.21907 3.84489 2.80961 4.31367 2.53565 4.86158C2.2617 5.40948 2.13235 6.01832 2.15988 6.63028C2.18742 7.24224 2.37092 7.83701 2.69297 8.3581C3.01503 8.87919 3.46493 9.30931 3.99997 9.60761C4.53501 9.90591 5.13742 10.0625 5.75 10.0625",
    stroke: "#394150",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 12.2188C4.41563 12.2188 3.13591 12.7488 2.19237 13.6924C1.24883 14.6359 0.71875 15.9156 0.71875 17.25H5.03125",
    stroke: "#394150",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4c5ee74577ea451a11da5c63272dac96.svg";
export { ForwardRef as ReactComponent };